var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boxblack"},[_c('h3',[_vm._v("Carregando imagem, não saia da pagina, aguarde...")]),_c('div',[_vm._v(_vm._s(_vm.porcente))]),_c('progress',{attrs:{"max":_vm.total},domProps:{"value":_vm.atual}})])}
var staticRenderFns = []

export { render, staticRenderFns }